import { Filter, Tag } from "lucide-react";
import type {
  DonationCategoryFilter,
  DonationMainCategoryOption,
} from "../../donation/types";

interface CategoryFilterProps {
  categories: DonationMainCategoryOption[];
  active: DonationCategoryFilter;
  onChange: (category: DonationCategoryFilter) => void;
}

export default function CategoryFilter({
  categories,
  active,
  onChange,
}: CategoryFilterProps) {
  return (
    <div className="scrollbar-hide flex items-center gap-2 overflow-x-auto pb-1">
      <button
        type="button"
        onClick={() => onChange("all")}
        className={`flex shrink-0 items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-all ${
          active === "all"
            ? "border-[#D4A017] bg-gradient-to-r from-[#D4A017] to-[#B8900F] text-white shadow-md shadow-[#D4A017]/20"
            : "border-gray-200 bg-white text-gray-700 hover:border-[#7A1E1E]/30 hover:text-[#7A1E1E]"
        }`}
      >
        <Filter className="h-4 w-4" />
        All
      </button>
      {categories.map(cat => {
        const isActive = active === cat.id;
        return (
          <button
            key={cat.id}
            type="button"
            onClick={() => onChange(cat.id)}
            className={`flex shrink-0 items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-all ${
              isActive
                ? "border-[#D4A017] bg-gradient-to-r from-[#D4A017] to-[#B8900F] text-white shadow-md shadow-[#D4A017]/20"
                : "border-gray-200 bg-white text-gray-700 hover:border-[#7A1E1E]/30 hover:text-[#7A1E1E]"
            }`}
          >
            <Tag className="h-4 w-4" />
            {cat.name}
          </button>
        );
      })}
    </div>
  );
}
